import {TextBody} from '@stripe-internal/conversations-ui';
import {useAnalytics} from '@stripe-internal/inline-data';
import {inlineLinkClickedActionEvent} from './analytics';
import {
  InlineLinkClickHandler,
  InlineLinkProps,
} from '../helpers/InlineLinkClickHandler';

export const ResponseMessageNext = ({text}: {text: string}) => {
  const analytics = useAnalytics();

  return (
    <InlineLinkClickHandler
      onClick={({href, innerText, parentInnerText}: InlineLinkProps) => {
        analytics.action(inlineLinkClickedActionEvent, {
          live_answers_source_url: href,
          live_answers_source_title: innerText,
          live_answers_source_context: parentInnerText,
        });
      }}
    >
      <TextBody body={text} />
    </InlineLinkClickHandler>
  );
};
